module.exports = __webpack_public_path__ + "media/dashboard/assets/images/patern-default-368be0861200a39a8871f3c6eadd04f5.png";